import React from "react";
import BlockStep from "./BlockStep";
import IconHalfCircle from "../../assets/components/blockStep/icon-half-circle.svg";
import IconSpinnerScale from "../../assets/components/blockStep/icon-spinner-scale.svg";
import IconArrows from "../../assets/components/blockStep/icon-arrows.svg";
import IconText from "../../assets/components/blockStep/icon-text.svg";
import IconSearch from "../../assets/components/blockStep/icon-search.svg";

const DefaultSteps = [
  {
    number: 1,
    color: "blue",
    icon: IconHalfCircle,
    text: "Choose black-white scale",
    boxType: "start",
  },
  {
    number: 2,
    color: "orange",
    icon: IconSpinnerScale,
    text: "Set the maximum intensity of the scale to the maximum intensity of all the brain pixels",
    boxType: "mid",
  },
  {
    number: 3,
    color: "gray",
    icon: IconArrows,
    text: "Ensure optimum size of images",
    boxType: "mid",
  },
  {
    number: 4,
    color: "blue",
    icon: IconText,
    text: "Review every transverse image from the bottom to the top of the brain",
    boxType: "mid",
  },
  {
    number: 5,
    color: "orange",
    icon: IconSearch,
    text: "Determine if scan is positive or negative",
    boxType: "end",
  },
];

// JSDoc type definitions
/**
 * @typedef Step
 * @property {number} number - The step number.
 * @property {string} color - The color class for the step.
 * @property {string} icon - The icon representing the step.
 * @property {string} text - The text description of the step.
 * @property {string} boxType - The type of box background for the step. Can be 'start', 'mid', or 'end'.
 */

/**
 * LdsBlockSteps component
 * @param {Object} props - The properties for the LdsBlockSteps component.
 * @param {Step[]} [props.steps] - An array of step objects to display. Defaults to DefaultSteps.
 * @returns {React.JSX.Element}
 */

const LdsBlockSteps = ({ steps = DefaultSteps }) => {
  return (
    <div className="blockSteps">
      {steps.map((step, index) => {
        return <BlockStep key={index} step={step} />;
      })}
    </div>
  );
};

export default LdsBlockSteps;
